"use client";

import { createContext, useContext, useState, useEffect } from "react";

export type Agency = {
  id?: string;
  slug?: string;
  lmsName?: string;
  name?: string;
  adresse?: string;
  phone?: string;
  phoneIdelio?: string;
  idSalesforce?: string;
  showIdelioButton?: boolean;
};

type GeoContextType = {
  agency: Agency | null;
  setAgency: (a: Agency | null) => void;
  hasSelected: boolean;
  setHasSelected: (v: boolean) => void;
  clearAgency: () => void;
};

const GeoContext = createContext<GeoContextType>({
  agency: null,
  setAgency: () => {},
  hasSelected: false,
  setHasSelected: () => {},
  clearAgency: () => {},
});

export function GeoProvider({ children }: { children: React.ReactNode }) {
  const [agency, setAgency] = useState<Agency | null>(null);
  const [hasSelected, setHasSelected] = useState(false);

  // Sauvegarde automatique à chaque changement d’agence
  useEffect(() => {
    if (agency) {
      localStorage.setItem("selectedAgency", JSON.stringify(agency));
      localStorage.setItem("hasSelected", JSON.stringify(true));
    }
  }, [agency]);

  // Chargement automatique au démarrage
  useEffect(() => {
    const storedAgency = localStorage.getItem("selectedAgency");
    const storedSelected = localStorage.getItem("hasSelected");

    if (storedAgency) setAgency(JSON.parse(storedAgency));
    if (storedSelected) setHasSelected(JSON.parse(storedSelected));
  }, []);

  // Réinitialisation (utilisée avant de définir une nouvelle agence)
  const clearAgency = () => {
    setAgency(null);
    setHasSelected(false);
    localStorage.removeItem("selectedAgency");
    localStorage.removeItem("hasSelected");
    console.log("🧹 Ancienne agence supprimée du localStorage");
  };

  return (
    <GeoContext.Provider value={{ agency, setAgency, hasSelected, setHasSelected, clearAgency }}>
      {children}
    </GeoContext.Provider>
  );
}

export function useGeo() {
  return useContext(GeoContext);
}
